module.exports = __webpack_public_path__ + "img/331474216.91e44a50.jpg";